import BillsModalsHub from './BillsModalsHub';

export default BillsModalsHub;
